import React, { useState } from 'react';
import TabFriday from './TabDay/TabFriday';
import TabMonday from './TabDay/TabMonday';
import TabSaturday from './TabDay/TabSaturday';
import TabSunday from './TabDay/TabSunday';
import TabThursday from './TabDay/TabThursday';
import TabTuesday from './TabDay/TabTuesday';
import TabWednesday from './TabDay/TabWednesday';

const TabSlotDelivery = () => {
  const [showTabDay, SetShowTabDay] = useState(1);
  let showDay = null;
  switch (showTabDay) {
    case 1:
      showDay = <TabMonday />;
      break;
    case 2:
      showDay = <TabTuesday />;
      break;
    case 3:
      showDay = <TabWednesday />;
      break;
    case 4:
      showDay = <TabThursday />;
      break;
    case 5:
      showDay = <TabFriday />;
      break;
    case 6:
      showDay = <TabSaturday />;
      break;
    case 7:
      showDay = <TabSunday />;
      break;

    default:
      return <div> Error </div>;
  }
  return (
    <div className="flex flex-col">
      <h4 className="text-font-gray mb-6">Pengantaran</h4>
      <div className="flex w-full">
        <div className="px-1">
          <div
            className={
              ' px-5 py-2  rounded-t-md cursor-pointer  border boder-gray-light-100  ' +
              (showTabDay === 1
                ? '  bg-white text-green-100'
                : ' bg-background-white text-font-gray')
            }
            onClick={() => {
              SetShowTabDay(1);
            }}
          >
            Senin
          </div>
        </div>
        <div className="px-1 border-b border-gray-light-100">
          <div
            className={
              ' px-5 py-2  rounded-t-md cursor-pointer  border boder-gray-light-100  ' +
              (showTabDay === 2
                ? '  bg-white text-green-100'
                : ' bg-background-white text-font-gray')
            }
            onClick={() => {
              SetShowTabDay(2);
            }}
          >
            Selasa
          </div>
        </div>
        <div className="px-1 border-b border-gray-light-100">
          <div
            className={
              ' px-5 py-2  rounded-t-md cursor-pointer  border boder-gray-light-100  ' +
              (showTabDay === 3
                ? '  bg-white text-green-100'
                : ' bg-background-white text-font-gray')
            }
            onClick={() => {
              SetShowTabDay(3);
            }}
          >
            Rabu
          </div>
        </div>
        <div className="px-1 border-b border-gray-light-100">
          <div
            className={
              ' px-5 py-2  rounded-t-md cursor-pointer  border boder-gray-light-100  ' +
              (showTabDay === 4
                ? '  bg-white text-green-100'
                : ' bg-background-white text-font-gray')
            }
            onClick={() => {
              SetShowTabDay(4);
            }}
          >
            Kamis
          </div>
        </div>
        <div className="px-1 border-b border-gray-light-100">
          <div
            className={
              ' px-5 py-2  rounded-t-md cursor-pointer  border boder-gray-light-100  ' +
              (showTabDay === 5
                ? '  bg-white text-green-100'
                : ' bg-background-white text-font-gray')
            }
            onClick={() => {
              SetShowTabDay(5);
            }}
          >
            Jumat
          </div>
        </div>
        <div className="px-1 border-b border-gray-light-100">
          <div
            className={
              ' px-5 py-2  rounded-t-md cursor-pointer  border boder-gray-light-100  ' +
              (showTabDay === 6
                ? '  bg-white text-green-100'
                : ' bg-background-white text-font-gray')
            }
            onClick={() => {
              SetShowTabDay(6);
            }}
          >
            Sabtu
          </div>
        </div>
        <div className="px-1 border-b border-gray-light-100">
          <div
            className={
              ' px-5 py-2  rounded-t-md cursor-pointer  border boder-gray-light-100  ' +
              (showTabDay === 7
                ? '  bg-white text-green-100'
                : ' bg-background-white text-font-gray')
            }
            onClick={() => {
              SetShowTabDay(7);
            }}
          >
            Minggu
          </div>
        </div>
      </div>
      <div className="flex py-4 w-full">{showDay}</div>
    </div>
  );
};

export default TabSlotDelivery;
